import moment from 'moment-timezone';
import OutputTextbox from './OutputTextbox.jsx';

export default class RVCTextbox extends OutputTextbox {
  formatLog(log) {
    const timezone = moment.tz.guess();
    const dateFormat = 'ddd, MMM DD YYYY, h:mm:ss a z';

    let formattedLog = log.map((line) => {
      let result = '';

      if (line.timestamp) {
        result += `[${moment(Date.parse(line.timestamp)).tz(timezone).format(dateFormat)}] `;
      }
      if (line.content) {
        result += line.content;
      }

      return result;
    });

    return formattedLog;
  }

  eventUpdate(data) {
    if (data.hostname == this.props.hostname) {
      this.setState({ output: this.formatLog(data.parsed_log) });
    }
  }
}
